import { render, staticRenderFns } from "./fullScreenImage.vue?vue&type=template&id=c8b7ad02&scoped=true"
import script from "./fullScreenImage.vue?vue&type=script&lang=js"
export * from "./fullScreenImage.vue?vue&type=script&lang=js"
import style0 from "./fullScreenImage.vue?vue&type=style&index=0&id=c8b7ad02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b7ad02",
  null
  
)

export default component.exports